import { render, staticRenderFns } from "./socialConnections.vue?vue&type=template&id=8c0034ac"
import script from "./socialConnections.vue?vue&type=script&lang=js"
export * from "./socialConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports